import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart, ArrowLeft } from 'lucide-react';

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-slate-100 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 group">
              <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center">
                <Heart className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold text-slate-800">A1C Survival Plan</span>
            </Link>
            <Link 
              to="/" 
              className="flex items-center gap-2 text-slate-600 hover:text-teal-600 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="prose prose-slate prose-lg max-w-none">
          <h1 className="text-4xl font-bold text-slate-800 mb-2">Cookie Policy</h1>
          <p className="text-xl text-teal-600 font-medium mb-2">A1C Survival Plan</p>
          <p className="text-slate-500 mb-8">Effective Date: December 01, 2025</p>

          <p className="text-slate-600 leading-relaxed">
            A1C Survival Plan uses cookies and similar technologies on our website to ensure proper 
            functionality and improve user experience.
          </p>

          <hr className="my-8 border-slate-200" />

          <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">What Are Cookies?</h2>
          <p className="text-slate-600 leading-relaxed">
            Cookies are small text files stored on your device when you visit a website.
          </p>

          <hr className="my-8 border-slate-200" />

          <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">How We Use Cookies</h2>
          <p className="text-slate-600 leading-relaxed">
            We use cookies to:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mt-4">
            <li>Enable essential website functionality</li>
            <li>Understand how visitors interact with our site</li>
            <li>Improve performance and content</li>
          </ul>
          <p className="text-slate-600 leading-relaxed mt-4 font-medium">
            We do not use cookies for advertising or selling data.
          </p>

          <hr className="my-8 border-slate-200" />

          <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">Third-Party Cookies</h2>
          <p className="text-slate-600 leading-relaxed">
            We may use trusted third-party tools (such as analytics providers) that set cookies to 
            help us understand website usage.
          </p>

          <hr className="my-8 border-slate-200" />

          <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">Your Choices</h2>
          <p className="text-slate-600 leading-relaxed">
            You can control or disable cookies through your browser settings. Note that some site 
            features may not function properly without cookies.
          </p>

          <hr className="my-8 border-slate-200" />

          <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">Changes to This Policy</h2>
          <p className="text-slate-600 leading-relaxed">
            We may update this policy as our website evolves.
          </p>

          <hr className="my-8 border-slate-200" />

          <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">Contact Us</h2>
          <p className="text-slate-600 leading-relaxed">
            For questions about cookies, contact:
          </p>
          <div className="bg-slate-50 rounded-2xl p-6 mt-4">
            <p className="text-slate-600">
              <span className="font-medium">Email:</span>{' '}
              <a href="mailto:support@a1csurvivalplan.com" className="text-teal-600 hover:text-teal-700">
                support@a1csurvivalplan.com
              </a>
            </p>
            <p className="text-slate-600 mt-2">
              <span className="font-medium">App Name:</span> A1C Survival Plan
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-50 border-t border-slate-100 mt-16">
        <div className="max-w-4xl mx-auto px-6 py-8 text-center">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} A1C Survival Plan. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default CookiePolicy;
